import React from 'react';

const PresentationList = ({ presentations }) => {
  const handleViewPresentation = (presentation) => {
    // Open PDF in new tab for full-page presentation view
    const fileUrl = getFileUrl(presentation.fileUrl);
    window.open(fileUrl, '_blank', 'noopener,noreferrer');
  };

  const getFileUrl = (apiPath) => {
    // Construct the full URL to the PDF file API endpoint
    // REACT_APP_BACKEND_URL includes /api suffix, so remove it to get base server URL
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const baseUrl = backendUrl.replace('/api', '');
    return `${baseUrl}${apiPath}`;
  };

  if (presentations.length === 0) {
    return (
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900">No presentations available</h3>
        <p className="mt-1 text-sm text-gray-500">Check back later for community presentations and demos.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-6 mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Community Presentations</h2>
        <p className="text-gray-600">
          Watch our demos and presentations used in community outreach programs
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {presentations.map((presentation) => (
          <div
            key={presentation.id}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            <div className="p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {presentation.title}
                  </h3>
                  {presentation.description && (
                    <p className="text-sm text-gray-600 mb-4">
                      {presentation.description}
                    </p>
                  )}
                  <div className="flex items-center text-xs text-gray-500 mb-4">
                    <svg
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                      />
                    </svg>
                    PDF Document
                  </div>
                </div>
              </div>
              <button
                onClick={() => handleViewPresentation(presentation)}
                className="w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors duration-200 flex items-center justify-center"
              >
                <svg
                  className="h-5 w-5 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
                Open Presentation
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PresentationList;
